import React from "react";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { Columns3 } from "lucide-react";
import { OPTIONAL_COLUMNS, OptionalColumn } from "@/types/bulkAd";

interface ColumnVisibilityDropdownProps {
  visibleColumns: OptionalColumn[];
  onToggleColumn: (column: OptionalColumn) => void;
}

export function ColumnVisibilityDropdown({
  visibleColumns,
  onToggleColumn,
}: ColumnVisibilityDropdownProps) {
  const [open, setOpen] = useState(false);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="outline" size="sm" className="h-8 gap-1.5">
          <Columns3 className="h-4 w-4" />
          Add Dimensions
          {visibleColumns.length > 0 && (
            <span className="ml-1 bg-primary/20 text-primary rounded-full px-1.5 py-0.5 text-xs">
              {visibleColumns.length}
            </span>
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-56" align="end">
        <div className="space-y-3">
          <p className="text-sm font-medium text-muted-foreground">
            Toggle optional columns
          </p>
          <div className="space-y-2">
            {OPTIONAL_COLUMNS.map((col) => (
              <label
                key={col.key}
                className="flex items-center gap-2 cursor-pointer hover:bg-muted/50 rounded px-2 py-1.5 -mx-2"
              >
                <Checkbox
                  checked={visibleColumns.includes(col.key)}
                  onCheckedChange={() => onToggleColumn(col.key)}
                />
                <span className="text-sm">{col.label}</span>
              </label>
            ))}
          </div>
        </div>
      </PopoverContent>
    </Popover>
  );
}
